export enum CodeType {
	internal = "internal",
	external = "external"
}